"use client";

import Link from "next/link";
import { 
  Cloud, 
  Code2,
  BrainCircuit, 
  ArrowRight 
} from "lucide-react";

export default function ServicesGrid() {
  const services = [
    {
      title: "Gen AI Blueprint",
      icon: <BrainCircuit className="h-6 w-6 text-red-600" />,
      description: "Define your AI roadmap and identify high-impact use cases in 90 minutes.",
      href: "/gen-ai"
    },
    {
      title: "AWS Solutions",
      icon: <Cloud className="h-6 w-6 text-red-600" />,
      description: "Migration, modernization, and well-architected framework reviews.",
      href: "/aws"
    },
    {
      title: "Software Solutions",
      icon: <Code2 className="h-6 w-6 text-red-600" />,
      description: "Full-cycle SaaS, mobile app development, and fractional CTO leadership.",
      href: "/software"
    }
  ];

  return (
    <div className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 pt-8 pb-16 md:pt-10 md:pb-24">
        <div className="flex flex-col md:flex-row justify-between items-end mb-8 md:mb-12 gap-6">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Our Expertise</h2>
            <p className="text-slate-600 max-w-xl">
              End-to-end technology services designed to help you scale faster.
            </p>
          </div>
          {/* UPDATED LINK HERE */}
          <Link 
            href="/case-studies" 
            className="text-red-600 font-bold hover:text-red-700 flex items-center group"
          >
            View Case Studies <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => (
            <Link 
              key={service.title} 
              href={service.href}
              className="group bg-white p-8 rounded-2xl border border-slate-200 hover:border-red-100 hover:shadow-xl transition-all duration-300"
            >
              <div className="bg-red-50 h-12 w-12 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-red-600 transition-colors">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {service.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}